import { Button, Col, Dropdown, Input, Menu, Row, Skeleton } from "antd";
import React, { useEffect, useState } from "react";
import { PlusOutlined, LeftSquareOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import RotoMain from "./RotoMain";
import SimilarRotoTender from "./SimilarRotoTender";
import RotoCircularTemplate from "./CircularTemplate";
import Header from "components/Header/index";
const addcompany = "assets/svg/addcompany.svg";
const defaultRoute = "/roto/rotoOnly";

const Roto = () => {
  const history = useHistory();
  const [openForm, setOpenForm] = useState({
    drawer: false,
    modal: false,
    edit: false,
  });

  const [SearchKeyword, setSearchKeyword] = useState();
  const [inputSearchValue, setInputSearchValue] = useState();

  const [state, setState] = useState({
    current: null,
    collapsed: false,
  });

  // added
  const [isCircularModalOpen, setIsCircularModalOpen] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [isCircularAddEditModalOpen, setIsCircularAddEditModalOpen] =
    useState(false);
  const [circularAddEdit, setCircularAddEdit] = useState({
    add: false,
    edit: false,
    data: {},
  });
  const [templateData, setTemplateData] = useState([]);
  const [isPersonModalVisible, setIsPersonModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [selectedAttendees, setSelectedAttendees] = useState([]);
  const [isLeftColumnCollapsible, setIsLeftColumnCollapsible] = useState(true);

  const menu = (
    <Menu style={{ width: 144 }}>
      <Menu.Item
        className="sidebars__menu--item"
        onClick={() => {
          setOpenForm({ drawer: true, modal: false });
        }}
      >
        <div
          style={{
            display: "flex",
            width: 114,
            justifyContent: "space-around",
          }}
        >
          <div style={{ width: "18%" }}>
            <img src={addcompany} />
          </div>
          <div style={{ width: "50%" }}> Roto</div>
        </div>
      </Menu.Item>
    </Menu>
  );

  const handleClick = (e) => {
    history.push(e.key);
  };

  useEffect(() => {
    if (history.location.pathname === "/roto") {
      history.push(defaultRoute);
    }
    setState({ ...state, current: history.location.pathname });
  }, [history.location.pathname]);

  const renderComponent = (pathname) => {
    switch (pathname) {
      case defaultRoute:
        return <RotoMain openForm={openForm} setOpenForm={setOpenForm} />;

      case "/roto/similarRotoTender":
        return <SimilarRotoTender />;
      case "/roto/circularTemplate":
        return <RotoCircularTemplate />;

      default:
        return <RotoMain openForm={openForm} setOpenForm={setOpenForm} />;
    }
  };

  if (!state.current) {
    return <Skeleton />;
  }

  const animateDiv = {
    opacity: isLeftColumnCollapsible ? 1 : 0,
    transition: "opacity 0.5s ease",
  };
  return (
    <>
      <div className="layout">
        <div className="organizer contacts">
          <div className="contactDetails__split">
            <div
              className={`side-bg-header-wrapper ${
                isLeftColumnCollapsible
                  ? "contactDetails__split--pagination"
                  : "contactDetails__split--pagination-collapse"
              } `}
            >
              <Header
                name="Businesss"
                isLeftColumnCollapsible={isLeftColumnCollapsible}
                setIsLeftColumnCollapsible={setIsLeftColumnCollapsible}
              />
              <div style={animateDiv}>
                <div className="search-wrapper">
                  {/* <StarFilled
                // onClick={(e) => {
                //   getData();
                //   getDataOthers();
                //   getDataProject();
                //   setSearchKeyword("");
                //   setInputSearchValue("");
                // }}
                style={{ color: starColor }}
                height="10"
                width="10"
              /> */}

                  <Input.Search
                    className="form__group"
                    style={{ margin: 0 }}
                    placeholder="Search"
                    size="medium"
                    allowClear
                    onSearch={(e) => {
                      setSearchKeyword(e);
                    }}
                    onPressEnter={(e) => {
                      setInputSearchValue(e.target.value);
                    }}
                    value={inputSearchValue}
                    // onClick={() => {
                    // 	setshowAll(true);
                    // }}
                    // onClcik={(e) => setSearchKeyword(e.target.value)}
                    // value={SearchKeyword}
                    // onClick={showModal}
                    autoComplete="off"
                  />

                  <Dropdown
                    overlay={menu}
                    arrow
                    trigger={["click"]}
                    // arrow
                    placement="bottomRight"
                  >
                    <div className="contactDetails__dropdown">
                      <Button className="contact__header__btn-primary">
                        <PlusOutlined />
                      </Button>
                    </div>
                  </Dropdown>
                </div>
                <Row
                  gutter={[8, 8]}
                  style={{ marginTop: "-12px", height: "36%" }}
                >
                  <Col span={24}>
                    <div className="profiledetails">
                      <Menu
                        className="sidebars__menu--items"
                        selectedKeys={[state.current]}
                        mode="inline"
                      >
                        <Menu.Item
                          key={defaultRoute}
                          onClick={handleClick}
                          className="sidebars__menu--item"
                        >
                          Roto
                        </Menu.Item>
                        <Menu.Item
                          key="/roto/similarRotoTender"
                          onClick={handleClick}
                          className="sidebars__menu--item"
                        >
                          SimilarRotoTender
                        </Menu.Item>
                        {/* <Menu.Item
                          key="/roto/circularTemplate"
                          onClick={handleClick}
                          className="sidebars__menu--item"
                        >
                          Circular Template
                        </Menu.Item> */}
                      </Menu>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div className="main__body" style={{ width: "calc(100% - 299px)" }}>
              {renderComponent(history.location.pathname)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Roto;
